export default "__VITE_ASSET__77e3447c__"